import DashboardService from '@/api/admin/dashboard.service'

export default {
  state: {
    wrapper: {},
    propertyStats: [],
    statsData: {
      summaryStats: {},
      fillRateWithProtectionChartStats: {},
      fillRateWithoutProtectionChartStats: {},
      viewsChartStats: {},
      clicksChartStats: {},
      actionsChartStats: {},
      adRequestVideoActionsChartStats: {},
      impressionsChartStats: {},
    },
    table: {
      rows: [],
      searchTerm: '',
    },
  },
  getters: {
    dashboardModel: state => state.wrapper,
    propertyStats: state => state.propertyStats,
    statsData: state => state.statsData,
    propertyTable: state => state.table,
  },
  actions: {
    async getDashboard({ commit }) {
      const response = await DashboardService.getDashboard()
      commit('SET_DASHBOARD_DATA', response)
    },
    async getPropertyStats({ commit }, filter) {
      const response = await DashboardService.getPropertyStats(filter)
      commit('SET_PROPERTY_STATS_DATA', response)
    },
    async getStats({ commit }, filter) {
      const response = await DashboardService.getStats(filter)
      commit('SET_STATS_DATA', response)
    },
  },
  mutations: {
    SET_DASHBOARD_DATA(state, model) {
      state.wrapper = model
    },
    SET_PROPERTY_STATS_DATA(state, model) {
      state.propertyStats = model
      state.table.rows = model
    },
    SET_STATS_DATA(state, model) {
      state.statsData.fillRateWithProtectionChartStats = model.fillRateWithProtection
      state.statsData.fillRateWithoutProtectionChartStats = model.fillRateWithoutProtection
      state.statsData.viewsChartStats = model.views
      state.statsData.clicksChartStats = model.clicks
      state.statsData.actionsChartStats = model.actions
      state.statsData.adRequestVideoActionsChartStats = model.adRequestVideoActions
      state.statsData.summaryStats = model.summary
      state.statsData.impressionsChartStats = model.impressions
    },
  },
}
